import {
  getNameDescriptionTableColumn,
  getProjectTableColumn,
  getTimeTableColumn,
  getPublicScopeTableColumn,
  getStatusTableColumn,
} from '@/utils/common/tableColumn'
import {
  getImageNameTableColumn,
  getImageLabelTableColumn,
  getRegistryTableColumn,
  getCommandTableColumn,
  getArgsTableColumn,
  getEnvsTableColumn,
} from '../utils/columns'

export default {
  created () {
    this.columns = [
      getNameDescriptionTableColumn({
        onManager: this.onManager,
        hideField: true,
        slotCallback: row => {
          return (
            <side-page-trigger onTrigger={() => this.handleOpenSidepage(row)}>{row.name}</side-page-trigger>
          )
        },
        formRules: [
          { required: true, message: this.$t('compute.text_210') },
          { validator: this.$validate('imageName') },
        ],
      }),
      getStatusTableColumn({ statusModule: 'containerImage' }),
      getImageNameTableColumn(),
      getImageLabelTableColumn(),
      getRegistryTableColumn({ vm: this }),
      getCommandTableColumn(),
      getArgsTableColumn(),
      getEnvsTableColumn(),
      getProjectTableColumn(),
      getPublicScopeTableColumn({
        vm: this,
        resource: 'container_images',
      }),
      getTimeTableColumn(),
    ]
  },
}
